import { customAxios } from '../../common/customAxios';

interface postUsersInquiryTractorParams {
  reqBody: {
    productId: string;
    inquiryUserPhoneNumber?: string;
  };
}

export const postUsersInquiryTractor = ({ reqBody }: postUsersInquiryTractorParams): Promise<void> => {
  return customAxios.post('/inquiries/tractors', reqBody);
};
